import styled from '@emotion/styled'

export const CreateStarChartOrgHeaderWrapper = styled.div`
  width: 94%;
  margin-left:3%;
  margin-bottom:10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius :6px;
   box-shadow: 0 3px 6px rgba(0, 0, 0,0.18);
   margin-top:9px;
    flex-direction: column;
    overflow: hidden;
   justify-content: center;
 
`

export const CreateStarChartOrgContentContainer = styled.div`
  width: 94%;
  margin-left:3%;
  margin-bottom:10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius :6px;
   box-shadow: 0 3px 6px rgba(0, 0, 0,0.18);
   margin-top:9px;
    flex-direction: column;
    overflow: hidden;
   justify-content: center;
   padding-top:17px;
 
`
export const CreateStarChartOrgExperienceList = styled.div`
 width:100%;
  margin-top:3%;

 
`


export const CreateStarChartOrgHeaderBanner = styled.div`
width:100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
   background-color: #000;
   justify-content: center;
   height: 110px;
`


export const CreateStarChartOrgHeaderText = styled.h2`
  color: #fff;
`


export const CreateStarChartOrgHeaderIcon = styled.img`
    max-width: 64px;
    position: absolute;
    right: 100px;
`

export const CreateStarChartOrgHeaderBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
   padding:18px 35px;
`


export const StarChartOrgLabel = styled.label`
    font-size: 15px;
    line-height: 30px;

`
export const StarChartOrgSaveButton = styled.button<{
    spaceLeft: string
  }>`
    background: #34c38f;
    color: white;
    border: none;
    padding: 10px;
    transition-duration:300ms;
    margin-left: ${({ spaceLeft }) => spaceLeft};
    font-family: "poppins", sans-serif;
    font-size: 14px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    font-weight: 300;
    width: fit-content;
    &:hover{
      box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
      transition-duration:300ms;
      background:#37d39a;
    }
    @media (max-width: 1770px) {
      font-size: 13px;
      margin-left: 20px;
    }
    span {
      white-space: nowrap;
    }
  
    &:disabled{
      color: whitesmoke;
      background-color: #cbcbcb;
      pointer-events: none;
    }
  `